var _style, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationMap(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:#CCE7FF;}\r\n\t.st2{fill:none;stroke:#1078FF;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st3{fill:none;stroke:#1078FF;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st4{fill:none;stroke:#1078FF;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st5{fill:none;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Duotone"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "20.5,5.5 18.5,5.5 16.5,5.5 16.5,3.7 11.5,0.5 6.5,3.7 6.5,5.5 4.5,5.5 2.5,5.5 0.5,23.5 22.5,23.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "11.5,0.5 11.5,4 13.5,5.3 13.5,7.3 11.5,8.5 11.5,15.5 16.5,8 16.5,3.7  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "18.5,5.5 20.5,5.5 22.5,23.5 0.5,23.5 2.5,5.5 4.5,5.5  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 1.2,
    y1: 17.5,
    x2: 21.8,
    y2: 17.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 17.5,
    y1: 10.5,
    x2: 21.1,
    y2: 10.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 1.9,
    y1: 10.5,
    x2: 5.5,
    y2: 10.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 6,
    y1: 23.5,
    x2: 6.7,
    y2: 13
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 17,
    y1: 23.5,
    x2: 16.3,
    y2: 13
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "11.5,15.5 16.5,8 16.5,3.7 11.5,0.5 6.5,3.7 6.5,8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "13.5,7.3 11.5,8.5 9.5,7.3 9.5,5.3 11.5,4 13.5,5.3  "
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Frames-24px"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st5",
    width: 24,
    height: 24
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationMap);
export default __webpack_public_path__ + "static/media/location-map.abd3796c20119f0ad8577ffdbaecd3e1.svg";
export { ForwardRef as ReactComponent };